import { observer } from 'mobx-react'
import React from 'react'

import { showCRMFailureToastWithGivenMessage } from '@flowwai-frontend/bps-officer-web/common/ui'
import { PinPurpose } from '@flowwai-frontend/bps-officer-web/graphql'
import { UserPIN } from '@flowwai-frontend/shared-web/iam/data-access'
import {
   UserPINUpdateMode,
   useUserPinState
} from '@flowwai-frontend/shared-web/iam/ui'
import { useCustomT } from '@flowwai-frontend/shared/common-components'

import { useSetUserSigningPin } from '../../apis/SetUserSigningPin/useSetUserSigningPin'
import UserPINInput from '../../components/UserPINInput/UserPINInput'

interface Props {
   mode: UserPINUpdateMode
   onPINUpdateSuccess: (userPIN: UserPIN) => void
   onCancel: () => void
}

const UserPINInputController = (props: Props): React.ReactElement => {
   const { mode, onPINUpdateSuccess, onCancel } = props

   const errorT = useCustomT('common:errorMessages')

   const userPinState = useUserPinState()

   const setUserSigningPinAPI = useSetUserSigningPin()

   const onSubmit = () => {
      setUserSigningPinAPI.triggerAPI({
         requestObj: {
            pin: userPinState.pin,
            pinPurpose: PinPurpose.ESign
         },
         onFailure(args) {
            showCRMFailureToastWithGivenMessage(
               args.data?.message ?? errorT('somethingWentWrong')
            )
         },
         onSuccess: onPINUpdateSuccess
      })
   }

   return (
      <UserPINInput
         mode={mode}
         pin={userPinState.pin}
         pinErrorMessage={userPinState.pinErrorMessage}
         confirmPin={userPinState.confirmPin}
         confirmPinErrorMessage={userPinState.confirmPinErrorMessage}
         apiStatus={setUserSigningPinAPI.apiStatus}
         isPINValid={userPinState.isPINValid}
         onChangePin={userPinState.onChangePin}
         onChangeConfirmPin={userPinState.onChangeConfirmPin}
         onSubmit={onSubmit}
         onCancel={onCancel}
      />
   )
}

export default observer(UserPINInputController)
